import * as featureFlagHooks from "store/hooks/featureFlagHooks";

const FeatureFlagged = ({
  flag,
  on,
  off,
  // This is to force the feature to be off. The intent is that this allows code to be
  // released behind a feature flag that even if the code is known not to work. So we
  // can start working on the integration without the risk that the feature flag is
  // accidentally enabled by someone who didn't know it wasn't ready.
  forceOff,
  defaultOn = false,
  ...props
}) => {
  const { isOn, isLoading } = featureFlagHooks.useFeatureFlag(flag, {
    default: defaultOn,
  });

  if (isLoading) {
    return <></>;
  }

  const Child = isOn && !forceOff ? on : off;

  return <Child {...props} />;
};

export default FeatureFlagged;
